export default __webpack_public_path__ + "static/N0314-8f99e283cad3a6d3c7b4ca2dab2f7640.png";